import html from './about.html?raw';
import '../../styles/polaroid.css';
import './about.css';
import markPhotoDark from '../../assets/images/about/mark-photo-dark.jpg';
import markPhotoLight from '../../assets/images/about/mark-photo-light.jpg';

interface ReviewsLoadedDetail {
  rating: number;
  total:  number;
  lang:   string;
}

function resolvePhoto(): string {
  return document.documentElement.getAttribute('data-theme') === 'light'
    ? markPhotoLight
    : markPhotoDark;
}

export function mount(target: HTMLElement): void {
  target.insertAdjacentHTML('beforeend', html);
}

document.addEventListener('DOMContentLoaded', () => {
  const photoEl = document.getElementById('about-photo') as HTMLImageElement | null;
  if (!photoEl) return;

  photoEl.src = resolvePhoto();

  new MutationObserver(() => {
    photoEl.src = resolvePhoto();
  }).observe(document.documentElement, { attributeFilter: ['data-theme'] });
});

document.addEventListener('reviewsloaded', (e) => {
  const { rating, total, lang } = (e as CustomEvent<ReviewsLoadedDetail>).detail;
  const ratingStr = lang === 'pl' ? rating.toFixed(1).replace('.', ',') : rating.toFixed(1);

  const titleEl = document.querySelector<HTMLElement>('[data-i18n="about.h4title"]');
  const descEl  = document.querySelector<HTMLElement>('[data-i18n="about.h4desc"]');

  if (titleEl) titleEl.textContent = (titleEl.textContent ?? '').replace('{rating}', ratingStr);
  if (descEl)  descEl.textContent  = (descEl.textContent  ?? '').replace('{n}', String(total));
});

